/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_Token_TitleInputs */

const cs_auth_reset_token_title = /** @type {(inputs: Auth_Reset_Token_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zvolte nové heslo`)
};

const en_auth_reset_token_title = /** @type {(inputs: Auth_Reset_Token_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a new password`)
};

/**
* | output |
* | --- |
* | "Choose a new password" |
*
* @param {Auth_Reset_Token_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_reset_token_title = /** @type {((inputs?: Auth_Reset_Token_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_Token_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_token_title(inputs)
	return cs_auth_reset_token_title(inputs)
});